// We'll use the new NALC logo that was uploaded
export const NALC_LOGO_URL = '/lovable-uploads/53d20b53-cf82-46b3-9fec-7f835cf99643.png';

// STANDARDIZED PRINT STYLES WITH HD QUALITY ENHANCEMENTS AND FIXED LAYOUT
export const getCommonPrintStyles = () => `
  /* HD QUALITY BASE RENDERING */
  * {
    -webkit-font-smoothing: antialiased !important;
    -moz-osx-font-smoothing: grayscale !important;
    text-rendering: optimizeLegibility !important;
    font-smooth: always !important;
    -webkit-text-stroke: 0.01em transparent !important;
    font-feature-settings: "liga", "kern" !important;
  }
  
  /* ENHANCED TEXT QUALITY */
  body, p, span, div, td, th, h1, h2, h3, h4, h5, h6 {
    -webkit-font-smoothing: antialiased !important;
    -moz-osx-font-smoothing: grayscale !important;
    text-rendering: optimizeLegibility !important;
    font-smooth: always !important;
    letter-spacing: 0.01em !important;
    line-height: 1.4 !important;
  }
  
  /* HD IMAGE RENDERING - ENHANCED FOR PROFILE IMAGES */
  img {
    image-rendering: -webkit-optimize-contrast !important;
    image-rendering: crisp-edges !important;
    -ms-interpolation-mode: bicubic !important;
    max-width: 100% !important;
    height: auto !important;
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
  }
  
  /* ENSURE STUDENT PROFILE IMAGES ARE VISIBLE */
  .student-avatar, .profile-image {
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
    image-rendering: -webkit-optimize-contrast !important;
    image-rendering: crisp-edges !important;
    -ms-interpolation-mode: bicubic !important;
  }

  /* PRINT PAGE LAYOUT - FIXED STICKY STRUCTURE */
  .print-page {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    position: relative;
    page-break-inside: avoid;
    padding: 0;
    margin: 0;
    width: 794px;
    max-width: 794px;
  }
  
  .print-header {
    position: sticky;
    top: 0;
    z-index: 1000;
    background: white;
    padding: 12px 16px;
    border-bottom: 2px solid #3D7069;
    margin-bottom: 10px;
    page-break-inside: avoid;
    page-break-after: avoid;
    width: 100%;
    box-sizing: border-box;
  }
  
  .print-content {
    flex: 1;
    padding: 0 20px;
    margin-bottom: 20px;
    min-height: 600px;
    width: 100%;
    box-sizing: border-box;
    max-width: 754px;
    margin-left: auto;
    margin-right: auto;
  }
  
  .print-footer {
    position: sticky;
    bottom: 0;
    z-index: 1000;
    background: white;
    padding: 12px 16px;
    border-top: 2px solid #3D7069;
    margin-top: auto;
    page-break-inside: avoid;
    page-break-before: avoid;
    width: 100%;
    box-sizing: border-box;
  }

  /* HEADER COMPONENTS WITH HD QUALITY */
  .header-flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 60px;
    width: 100%;
    max-width: 754px;
    margin: 0 auto;
  }
  
  .header-logo {
    width: 48px !important;
    height: 48px !important;
    object-fit: contain;
    margin-right: 15px;
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
    max-width: 48px !important;
    max-height: 48px !important;
    min-width: 48px !important;
    min-height: 48px !important;
    position: relative !important;
    z-index: 1001 !important;
    background-color: transparent !important;
    border: none !important;
    image-rendering: -webkit-optimize-contrast !important;
    image-rendering: crisp-edges !important;
    -ms-interpolation-mode: bicubic !important;
  }
  
  .header-texts {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  
  .header-date {
    margin-left: auto;
    font-size: 0.85em;
    color: #444;
    font-weight: 500;
    -webkit-font-smoothing: antialiased;
  }
  
  .institution-name {
    font-size: 1.5rem;
    margin: 0;
    font-weight: bold;
    color: #3D7069;
    letter-spacing: 0.02em;
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
  }
  
  .institution-subtitle {
    font-size: 0.95rem;
    color: #444;
    margin: 0;
    font-weight: 500;
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
  }
  
  .page-title {
    font-size: 0.9em;
    font-weight: bold;
    margin-top: 2px;
    color: #1a1a1a;
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
  }

  /* FOOTER COMPONENTS WITH ENHANCED QUALITY */
  .footer-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    width: 100%;
    max-width: 754px;
    margin: 0 auto;
  }
  
  .footer-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-size: 0.82em;
    color: #444;
    gap: 12px;
    flex-wrap: wrap;
    line-height: 1.3;
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
  }
  
  .footer-note {
    font-weight: bold;
    color: #c53939;
    letter-spacing: 0.01em;
    font-size: 0.82em;
    line-height: 1.2;
    text-align: center;
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
  }
  
  .footer-confidential {
    font-style: italic;
    color: #666;
    font-size: 0.75em;
    line-height: 1.2;
    text-align: center;
    -webkit-font-smoothing: antialiased;
  }
  
  .footer-copyright {
    color: #666;
    font-size: 0.75em;
    line-height: 1.2;
    text-align: center;
    -webkit-font-smoothing: antialiased;
  }

  /* SIGNATURE COMPONENTS WITH HD CLARITY */
  .signatures {
    display: flex;
    justify-content: space-between;
    margin: 20px 0 15px 0;
    min-height: 40px;
    align-items: flex-end;
    width: 100%;
    max-width: 754px;
    margin-left: auto;
    margin-right: auto;
  }
  
  .signature {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 160px;
    position: relative;
  }
  
  .signature-line {
    width: 100%;
    border-bottom: 1px solid #000;
    margin-bottom: 6px;
    height: 25px;
  }
  
  .signature-title {
    font-size: 0.8em;
    text-align: center;
    line-height: 1.2;
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
  }

  /* PAGE BREAKS AND CONTENT FLOW */
  .page-break {
    page-break-before: always;
    break-before: page;
  }
  
  .page-content {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    width: 794px;
    max-width: 794px;
  }

  /* HD GENERAL STYLING */
  body {
    font-family: Arial, sans-serif;
    line-height: 1.5;
    padding: 0;
    margin: 0;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
    width: 794px;
    max-width: 794px;
  }

  /* CRITICAL: ENSURE PROFILE IMAGES ARE VISIBLE */
  img:not(.header-logo) {
    display: block !important;
    visibility: visible !important;
    opacity: 1 !important;
  }
  
  /* ONLY HIDE NON-ESSENTIAL IMAGES, NOT PROFILE IMAGES */
  img.decorative-only {
    display: none !important;
    visibility: hidden !important;
    opacity: 0 !important;
    width: 0 !important;
    height: 0 !important;
  }
  
  /* CRITICAL: PREVENT DUPLICATE HEADERS AND FOOTERS */
  .print-page:not(:first-child) .print-header:not(:first-child) {
    display: none !important;
  }
  
  .print-page:not(:last-child) .print-footer:not(:last-child) {
    display: none !important;
  }

  /* HD PRINT MEDIA QUERIES - FIXED STICKY POSITIONING */
  @media print {
    /* HD BASE PRINT SETTINGS */
    * {
      -webkit-font-smoothing: antialiased !important;
      -moz-osx-font-smoothing: grayscale !important;
      text-rendering: optimizeLegibility !important;
      font-smooth: always !important;
    }
    
    body { 
      padding: 0;
      margin: 0;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      text-rendering: optimizeLegibility;
      width: 794px;
      max-width: 794px;
    }
    
    .print-page {
      min-height: 100vh;
      page-break-inside: avoid;
      width: 794px;
      max-width: 794px;
    }
    
    .print-header {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 1000;
      background: white;
      padding: 8px 12px;
      border-bottom: 2px solid #3D7069;
      width: 794px;
      max-width: 794px;
      box-sizing: border-box;
    }
    
    .print-content {
      margin-top: 80px;
      margin-bottom: 100px;
      padding: 0 20px;
      width: 100%;
      max-width: 754px;
      margin-left: auto;
      margin-right: auto;
      box-sizing: border-box;
    }
    
    .print-footer {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 1000;
      background: white;
      padding: 8px 12px;
      border-top: 2px solid #3D7069;
      width: 794px;
      max-width: 794px;
      box-sizing: border-box;
    }
    
    .header-logo {
      width: 40px !important;
      height: 40px !important;
      margin-right: 12px !important;
      image-rendering: -webkit-optimize-contrast !important;
      image-rendering: crisp-edges !important;
    }
    
    .institution-name { 
      font-size: 1.25rem;
      -webkit-font-smoothing: antialiased;
      text-rendering: optimizeLegibility;
    }
    
    .institution-subtitle { 
      font-size: 0.8rem;
      -webkit-font-smoothing: antialiased;
      text-rendering: optimizeLegibility;
    }
    
    .signatures {
      margin: 15px 0 10px 0;
      min-height: 35px;
      width: 100%;
      max-width: 754px;
      margin-left: auto;
      margin-right: auto;
    }
    
    .signature-line {
      height: 20px;
      margin-bottom: 5px;
    }
    
    /* Hide all buttons in print */
    button, .button, input[type="button"], input[type="submit"] {
      display: none !important;
    }
    
    /* ENSURE PROFILE IMAGES ARE VISIBLE IN PRINT */
    .student-avatar, .profile-image {
      display: block !important;
      visibility: visible !important;
      opacity: 1 !important;
      image-rendering: -webkit-optimize-contrast !important;
      image-rendering: crisp-edges !important;
    }
    
    /* ONLY HIDE DECORATIVE IMAGES, NOT PROFILE IMAGES */
    img.decorative-only {
      display: none !important;
      visibility: hidden !important;
      opacity: 0 !important;
      width: 0 !important;
      height: 0 !important;
    }
  }
  
  @page {
    size: A4;
    margin: 0.5in;
  }
`;

// STANDARDIZED HEADER FUNCTION
export const getHeaderHtml = (title: string) => `
  <div class="print-header">
    <div class="header-flex">
      <div style="display: flex; align-items: center;">
        <img src="${NALC_LOGO_URL}" alt="NALC Logo" class="header-logo"/>
        <div class="header-texts">
          <div class="institution-name">NALC</div>
          <div class="institution-subtitle"><em><strong>Noor Ali Learning Center</strong></em></div>
          <div class="page-title">${title || ""}</div>
        </div>
      </div>
      <div class="header-date">Generated on ${new Date().toLocaleDateString()}</div>
    </div>
  </div>
`;

export const getFooterHtml = (type = 'student') => `
  <div class="print-footer">
    <div class="footer-content">
      <div class="footer-row">
        <em><strong>Noor Ali Learning Center</strong></em>
        <span>Address: 3rd Zone, Arbaban 14th Street</span>
        <span>Tel: 0784350000</span>
        <span>Email: nalcjalalabad.official@gmail.com</span>
      </div>
      <div class="footer-note">NOTE: Without stamp the slip is invalid.</div>
      <div class="footer-confidential">
        This document is confidential and intended for educational purposes only
      </div>
      <div class="footer-copyright">
        © 2025 Noor Ali Learning Center. All rights reserved.
      </div>
    </div>
  </div>
`;

export const getSignatureHtml = (type = 'student') => {
  let rightSignatureTitle = 'Student';
  
  if (type === 'teacher') {
    rightSignatureTitle = 'Teacher';
  } else if (type === 'admin') {
    rightSignatureTitle = 'Admin';
  } else if (type === 'report') {
    // For reports, dashboard cards, only show authorized signature
    return `
      <div style="display: flex; justify-content: center; margin: 20px 0 15px 0;">
        <div class="signature" style="width: 180px;">
          <div class="signature-line"></div>
          <div class="signature-title">Authorized by</div>
        </div>
      </div>
    `;
  }
  
  return `
    <div class="signatures">
      <div class="signature">
        <div class="signature-line"></div>
        <div class="signature-title">Authorized by</div>
      </div>
      <div class="signature">
        <div class="signature-line"></div>
        <div class="signature-title">${rightSignatureTitle}</div>
      </div>
    </div>
  `;
};
